var exports = {
  "kL": "x31de4314--f40935--container",
  "Qs": "x31de4314--f40935--content",
  "uQ": "x31de4314--f40935--text-group",
  "r7": "x31de4314--f40935--image-slot",
};

module.exports = exports;
